import { render, staticRenderFns } from "./BaseButtonCreate.vue?vue&type=template&id=9ec5608a&"
import script from "./BaseButtonCreate.vue?vue&type=script&lang=ts&"
export * from "./BaseButtonCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports